import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SfgeService {

  private apiUrl =
    environment.apiUrl + '/sfge';

  constructor(
    private http: HttpClient
  ) { }

  create(request: any): Observable<any> {

    return this.http.post(
      this.apiUrl,
      request
    );
  }

  update(
    idSfge: number,
    request: any
  ): Observable<any> {

    return this.http.put(
      `${this.apiUrl}/${idSfge}`,
      request
    );
  }

  getByAccesso(
    idAccesso: number
  ): Observable<any> {

    return this.http.get(
      `${this.apiUrl}/accesso/${idAccesso}`
    );
  }

  delete(
    idSfge: number
  ): Observable<any> {

    return this.http.delete(
      `${this.apiUrl}/${idSfge}`
    );
  }

  getByPatient(
    idPaziente: number
  ): Observable<any[]> {

    return this.http.get<any[]>(
      `${this.apiUrl}/patient/${idPaziente}`
    );
  }

  getById(idSfge: number) {

    return this.http.get<any>(
      `${this.apiUrl}/${idSfge}`
    );
  }
}